import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthStore } from '../stores/auth.store';

export const redirectGuard: CanActivateFn = (): boolean | UrlTree => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.currentUser();

  if (!user?.privileges?.length) {
    return false;
  }

  const actionCodes = user.privileges.map((p) => p.actionCode);

  if (actionCodes.includes('PROFILE')) {
    return router.createUrlTree(['/profilo']);
  }

  if (actionCodes.includes('ACCOUNT_MANAGER')) {
    return router.createUrlTree(['/utenti']);
  }

  if (actionCodes.includes('STRUTTURE')) {
    return router.createUrlTree(['/strutture']);
  }

  return false;
};
